<template>
  <Widget
    :headline="$t('taskScheduler.headline')"
    :bottom="{
      label: $t('taskScheduler.widget.link'),
      href: ROUTE_TASK_SCHEDULER,
      onClick: () => $emit('onTrackingClick', '_link-' + $t('taskScheduler.widget.link'), 'link'),
    }"
  >
    <div v-if="tasksLoaded" :class="`${el}__widget`">
      <InViewAnimation>
        <TaskGoals :slot="1" :variant="taskGoalsVariant" />
      </InViewAnimation>
      <InViewAnimation :delay="1">
        <Copy :slot="1" :staticClass="`${el}__widgetSubline`" element="div" size="l" bold>
          {{ $t('taskScheduler.widget.subline') }}
        </Copy>
      </InViewAnimation>

      <InViewAnimation v-if="relevantTasksAreDone" :delay="2">
        <div :slot="1" :class="`${el}__done`">
          <Copy element="div" size="l" color="primaryBlue" bold centered>
            {{ $t('taskScheduler.done.headline') }}
          </Copy>
          <Copy element="div" size="l" color="tertiaryLight" centered>
            {{ $t('taskScheduler.done.subline.allTasks') }}
          </Copy>
        </div>
      </InViewAnimation>

      <InViewAnimation v-else :delay="2">
        <Tasks
          :slot="1"
          :task="currentTask"
          current
          @onTrackingClick="(data) => $emit('onTrackingClick', data + '_Antrag stellen', 'button')"
        />
      </InViewAnimation>
    </div>
    <Spinner v-else size="l" insideWidget />
  </Widget>
</template>

<script>
import Widget from '@/objects/Widget';
import Copy from '@/objects/Copy';
import Spinner from '@/objects/Spinner';
import TaskGoals from '@/components/TaskGoals';
import Tasks from '@/components/Tasks';
import InViewAnimation from '@/components/InViewAnimation';

import { ROUTE_TASK_SCHEDULER } from '@/constants/routes';

import mixin from './mixin';

import { mapFieldsAuth } from '@/store/mapFields';

export default {
  name: 'TaskSchedulerWidget',
  props: {},
  mixins: [mixin],
  components: {
    Widget,
    Copy,
    Spinner,
    TaskGoals,
    Tasks,
    InViewAnimation,
  },
  computed: {
    ...mapFieldsAuth(['isAuthenticated']),

    currentTask() {
      return this.isAuthenticated ? this.relevantTasks[0] : this.getItems(['P2-20'])[0];
    },
  },
  data() {
    return {
      ROUTE_TASK_SCHEDULER,
      el: 'v-taskScheduler',
    };
  },
};
</script>
